import type { TagProps } from './const';
import { IconClose } from '@wegic/icon';
import { forwardRef } from 'react';
import { cn } from '../../utils';
import './index.less';

function Tag(props: TagProps, ref: React.Ref<HTMLDivElement>) {
  const {
    color = 'gray',
    size = 'small',
    bordered = true,
    closable = false,
    onClose,
    icon,
    children,
    className,
    ...rest
  } = props;

  const handleClose = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    onClose?.(e);
  };

  return (
    <div
      {...rest}
      ref={ref}
      className={cn(
        'wg-tag',
        `wg-tag--${color}`,
        `wg-tag--${size}`,
        {
          'wg-tag--bordered': bordered,
          'wg-tag--closable': closable,
        },
        className,
      )}
    >
      {icon && <span className="wg-tag__icon">{icon}</span>}
      {children && <span className="wg-tag__text">{children}</span>}
      {closable && (
        <span className="wg-tag__close" onClick={handleClose}>
          <IconClose fontSize={12} />
        </span>
      )}
    </div>
  );
}

const TagComponent = forwardRef<HTMLDivElement, TagProps>(Tag);

TagComponent.displayName = 'Tag';

export default TagComponent;

export type { TagProps };
